import React, { useEffect } from 'react';
import styles from './procedimentos_thyagolashman.module.scss';
import { Link } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';

const WHATSAPP_NUMBER = '553298527555';

type Procedimento = {
    id: string;
    titulo: string;
    imagem: string;
};

const procedimentos: Procedimento[] = [
    {
        id: 'fio-a-fio-classico',
        titulo: 'Fio a Fio Clássico',
        imagem: require('./src/procedimentos/fio-a-fio-classico.png'),
    },
    {
        id: 'efeito-suave-preto',
        titulo: 'Efeito Suave Preto',
        imagem: require('./src/procedimentos/efeito-suave-preto.png'),
    },
    {
        id: 'efeito-suave-brown',
        titulo: 'Efeito Suave Brown',
        imagem: require('./src/procedimentos/efeito-suave-brown.png'),
    },
    {
        id: 'efeito-lami',
        titulo: 'Efeito Lami',
        imagem: require('./src/procedimentos/efeito-lami.png'),
    },
    {
        id: 'efeito-clean',
        titulo: 'Efeito Clean',
        imagem: require('./src/procedimentos/efeito-clean.png'),
    },
    {
        id: 'volume-brasileiro',
        titulo: 'Volume Brasileiro',
        imagem: require('./src/procedimentos/volume-brasileiro.png'),
    },
    {
        id: 'volume-brasileiro-brown',
        titulo: 'Volume Brasileiro Brown',
        imagem: require('./src/procedimentos/volume-brasileiro-brown.png'),
    },
    {
        id: 'mega-brasileiro',
        titulo: 'Mega Brasileiro',
        imagem: require('./src/procedimentos/mega-brasileiro.png'),
    },
    {
        id: 'fox-eyes',
        titulo: 'Fox Eyes',
        imagem: require('./src/procedimentos/fox-eyes.png'),
    },
    {
        id: 'fox-eyes-preto',
        titulo: 'Fox Eyes Preto',
        imagem: require('./src/procedimentos/fox-eyes-preto.png'),
    },
    {
        id: 'fox-eyes-brown',
        titulo: 'Fox Eyes Brown',
        imagem: require('./src/procedimentos/fox-eyes-brown.png'),
    },
    {
        id: 'fio-u',
        titulo: 'Fio U',
        imagem: require('./src/procedimentos/fio-u.png'),
    },
    {
        id: '5d-charme',
        titulo: '5D Charme',
        imagem: require('./src/procedimentos/5D-charme.png'),
    },
    {
        id: 'mega-charme',
        titulo: 'Mega Charme',
        imagem: require('./src/procedimentos/mega-charme.png'),
    },
    {
        id: 'sirena',
        titulo: 'Sirena',
        imagem: require('./src/procedimentos/sirena.png'),
    },
    {
        id: 'design-com-henna',
        titulo: 'Design com Henna',
        imagem: require('./src/procedimentos/design-com-henna.png'),
    },
];

interface CardProcedimentoProps {
    item: Procedimento;
}

const CardProcedimento: React.FC<CardProcedimentoProps> = ({ item }) => {
    const handleAgendamentoClick = () => {
        const msg = encodeURIComponent(
            `Olá! Vim pelo cartão digital e gostaria de agendar o procedimento: ${item.titulo}.`
        );
        window.open(`https://wa.me/${WHATSAPP_NUMBER}?text=${msg}`, '_blank', 'noopener,noreferrer');
    };

    return (
        <section className={styles.procedimento}>
            <div className={styles.carousel}>
                <img src={item.imagem} alt={item.titulo} />
            </div>

            <h3 className={styles.titulo}>{item.titulo}</h3>

            <button type="button" className={styles.agendarBtn} onClick={handleAgendamentoClick}>
                Agendar
            </button>
        </section>
    );
};

const Procedimentos_thyagolashman: React.FC = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className={styles.pageWrapper}>
            <div className={styles.procedimentos_thyagolashman}>
                <div className={styles.header}>
                    <Link to="/thyagolashman" className={styles.backButton} aria-label="Voltar">
                        <FaArrowLeft />
                    </Link>
                    <h2>Procedimentos</h2>
                </div>

                <div className={styles.lista}>
                    {procedimentos.map((item) => (
                        <CardProcedimento key={item.id} item={item} />
                    ))}
                </div>

                <section className={styles.ctaSection}>
                    <p className={styles.ctaTitle}>Pronta para agendar?</p>
                    <p className={styles.ctaText}>
                        Clique em Agendar no procedimento desejado e escolha o melhor horário para você.
                    </p>
                </section>
            </div>
        </div>
    );
};

export default Procedimentos_thyagolashman;
